module.exports = __webpack_public_path__ + "static/media/udemy2.4b07c691.png";